var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_c('canvas',{ref:"canvas",attrs:{"width":"400","height":"400"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }